/* eslint-disable @next/next/no-img-element */
/* -----------------Third parties--------------- */

import "react-image-crop/dist/ReactCrop.css";
import { Box, Loader } from "@memorang/ui";
import { useImageDimensions } from "@react-native-community/hooks";
import { useEffect, useRef } from "react";
//@ts-ignore
import CanvasDraw from "react-canvas-draw";
import { Card } from "react-native-paper";
import useAIFeedbackStore from "../hooks/useAIFeedbackStore";

/* -----------------Child components--------------- */

interface Props {
	image: string;
	itemId: number;
	isAnswered?: boolean;
}

const CANVAS_HEIGHT = 300;

const HotspotContainer = ({ image, itemId, isAnswered }: Props) => {
	const canvasRef = useRef<CanvasDraw | null>(null);

	const savedData = canvasRef.current?.getSaveData();

	const setUserResponse = useAIFeedbackStore((state) => state.setUserResponse);
	const setCanvasResponse = useAIFeedbackStore(
		(state) => state.setCanvasResponse,
	);
	const currentCanvasResponse = useAIFeedbackStore(
		(state) => state.canvasResponse,
	);

	const canvasResponse = currentCanvasResponse?.[itemId];

	const streaming = useAIFeedbackStore((state) => state.streaming);
	const hasSavedData = savedData
		? JSON.parse(savedData).lines.length > 0
		: false;

	const { dimensions, loading } = useImageDimensions({ uri: image });
	const displayWidth = dimensions
		? CANVAS_HEIGHT * dimensions.aspectRatio
		: CANVAS_HEIGHT;

	useEffect(() => {
		if (
			canvasResponse &&
			!hasSavedData &&
			!streaming &&
			isAnswered &&
			canvasRef.current &&
			!loading
		) {
			canvasRef.current.loadSaveData(canvasResponse);
		}
	}, [canvasResponse, hasSavedData, streaming, isAnswered, loading]);

	const handleOnChange = () => {
		if (canvasRef?.current && !canvasResponse) {
			const canvas = canvasRef.current.canvas.drawing;

			const combinedCanvas = document.createElement("canvas");
			combinedCanvas.width = canvas.width;
			combinedCanvas.height = canvas.height;
			const combinedCtx = combinedCanvas.getContext("2d");

			const img = new Image();
			img.crossOrigin = "anonymous";
			img.onload = () => {
				combinedCtx?.drawImage(img, 0, 0, canvas.width, canvas.height);
				combinedCtx?.drawImage(canvas, 0, 0);

				const combinedDataUrl = combinedCanvas.toDataURL();
				const canvasResponse = canvasRef.current.getSaveData();

				setUserResponse(itemId, combinedDataUrl);
				setCanvasResponse(itemId, canvasResponse);
			};
			img.src = image;
		}
	};

	if (loading) {
		return (
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				height={400}
			>
				<Loader />
			</Box>
		);
	}

	return (
		<Box gap={16} display="flex" justifyContent="center" alignItems="center">
			<Card
				style={{
					width: displayWidth,
					height: CANVAS_HEIGHT,
					overflow: "hidden",
					position: "relative",
				}}
			>
				<img
					src={image}
					alt=""
					crossOrigin="anonymous"
					style={{
						width: displayWidth,
						height: CANVAS_HEIGHT,
						objectFit: "fill",
						display: "block",
					}}
				/>
				<CanvasDraw
					onChange={handleOnChange}
					brushRadius={2}
					lazyRadius={2}
					brushColor={"red"}
					ref={canvasRef}
					canvasWidth={displayWidth}
					canvasHeight={CANVAS_HEIGHT}
					hideGrid
					backgroundColor="transparent"
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						width: displayWidth,
						height: CANVAS_HEIGHT,
					}}
				/>
			</Card>
		</Box>
	);
};

export default HotspotContainer;
